const raidbotsUpgradeEquippedModes = {
  'No changes': 'none',
  'Match Droptimizer Item Levels': 'match',
  'Max Upgrade Level': 'max',
}

export default raidbotsUpgradeEquippedModes
